<template>
<div class="box">
  <div class="row">
    <div class="col-md-12 m-3">
      <h3> Agent Accounts</h3>
    </div>
  </div>
  <hr/>
  <div class="row">
    <div class="col-md-12">
      <div class="wrap">
        <dl class="summary">
  
          <dt>Total invoice value</dt>
          <dd>{{ booking.total_due | formatCurrency }}</dd>

          <dt>Total receipts</dt>
          <dd>{{ booking.paid | formatCurrency }}</dd>
          
          <dt>Non-Commissionables</dt>
          <dd>{{ nonCommissionables |formatCurrency }}</dd>

          <dt class="no-dt"></dt>
          <dd class="form form--inline"></dd>

          <dt>Agent Comission</dt>
          <dd>{{  agentComission | formatCurrency }}</dd>

          <dt>Agent Comission (%) &nbsp;</dt>
          <dd class="form form--inline">
            <input type="number" v-model="booking.agent_comission_percent">
          </dd>

          <dt>Vat ({{ this.booking.booking_vat_percent }}%)</dt>
          <dd>{{  agentBookingVat | formatCurrency }}</dd>

          <dt>Deposit Due By</dt>
          <dd class="form form--inline">
            <input type="date" v-model="booking.deposit_due">
            <button class="button button--small" v-on:click="$emit('update-booking')">
              Update
            </button>
          </dd>

          <dt>Balance outstanding</dt>
          <dd>{{ bookinBalance | formatCurrency }}</dd>

          <dt>Balance Due by</dt>
          <dd class="form form--inline">
            <input type="date" v-model="booking.balance_due">
            <button class="button button--small" v-on:click="$emit('update-booking')">
              Update
            </button>
          </dd>
          

        </dl>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'BookingAgentAccounts',
  props : {
    booking: Object,
    totalDue: Number
  },
  computed: {
    nonCommissionables() {
      let non_commisionalbe_extras = 0;
      if (this.booking.non_commissionable_extras.length > 0 ) {
        non_commisionalbe_extras = this.booking.non_commissionable_extras.reduce((accumulator ,item) => {
          return accumulator += (item.price * item.pivot.qty);
        }, 0)
      }
      return non_commisionalbe_extras;
    },
    agentComission(){
      let bookingAmount = this.booking.total_due -this.nonCommissionables
      return bookingAmount * (Number(this.booking.agent_comission_percent) / 100)
    },
    agentBookingVat(){
      return this.agentComission * (Number(this.booking.booking_vat_percent) / 100)

    },
    bookinBalance() {
      let balance = (this.booking.total_due )  - this.booking.paid - (this.agentComission + this.agentBookingVat);
      return (balance > 0) ? balance : 0;
    }
  }
}
</script>


<style>

.summary dt.no-dt::after{
  content: none !important;
}

</style>
